import { RequestDocument, Variables } from 'graphql-request/dist/types'
import { Response, useAuth, useQuery } from '@aposphaere/core-kit'
import { useMemo } from 'react'

export const useAuthenticatedQuery = <ModelType>(query: RequestDocument, variables?: Variables): Response<ModelType> => {
  const auth = useAuth()
  const headers = useMemo(() => new Headers({ Authorization: auth.token }), [auth.token])
  return useQuery<ModelType>(query, variables, headers)
}
